<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <template v-if="cartsupp && cartsupp.items">
        <div class="bg-light">
          <div class="container section-header-breadcrumb">
            <div class="row">
              <div class="content text-left col-sm-12 col-md-12 col-lg-12">
                <h2 class="title-page">Livraison</h2>
                <label class="breadcrumb-text">
                  <span class="pointer-cursor" @click.prevent="GoToDashboard">Accueil</span> > 
                  <span class="pointer-cursor" @click.prevent="GoToStepCart">Mon panier</span> >
                  <span>Livraison</span>
                </label>
              </div>
            </div>
          </div>
          <div class="container livraison-page">
            <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
              <!-- Block Livraison -->
              <div class="col-12 col-lg-8 block-livraison">
                <div class="row step-cart">
                  <div class="col-11">
                    <div class="d-flex flex-column flex-md-row gap-2 gap-md-4 align-items-center justify-content-center py-3 py-md-4 step-cart-centent">
                      <div class="step-number d-flex align-items-center" @click.prevent="GoToStepCart">
                        <span class="badge mx-1 mx-md-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-100 h-75"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#ec621a"
                            stroke-width="3"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        </span>
                        <span class="step-title d-none d-sm-inline">Votre panier</span>
                      </div>
                      <div class="separator d-none d-md-block"></div>

                      <div class="step-number d-flex align-items-center">
                        <span class="badge badge-blue mx-1 mx-md-2">2</span>
                        <span class="step-title d-none d-sm-inline">Livraison</span>
                      </div>
                      <div class="separator d-none d-md-block"></div>

                      <div class="step-number d-flex align-items-center">
                        <span class="badge mx-1 mx-md-2">3</span>
                        <span class="step-title d-none d-sm-inline">Paiement</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row justify-content-center mt-3 mt-md-4">
                  <div class="col-12 col-lg-10 my-2 d-flex justify-content-center justify-content-lg-start">
                    <img :src="iconshipping" class="shipping-icon" alt="Icône livraison" />
                    <label class="title-blue my-auto px-2 text-center text-lg-start">Choisissez votre mode de livraison</label>
                  </div>
                </div>
                
                <div class="row justify-content-center modes-livraison">
                  <div class="col-12 col-lg-10 my-2">
                    <form class="radio-group">
                      <label
                        v-for="mode in ModesLivraison"
                        :key="mode.id"
                        class="radio-option"
                        :class="{
                          selected: selected === mode.id,
                        }"
                      >
                        <div class="radio-input-title">
                          <input type="radio" :value="mode.id" v-model="selected" name="mode_livraison" />
                          <div class="radio-title">
                            {{ mode.name }}
                          </div>
                        </div>

                        <div class="radio-content">
                          <div
                            class="radio-description mt-2 mt-md-3 mb-2 mb-md-3"
                            v-html="$sanitize.sanitizeDeliveryContent(mode.descriptionLong)"
                          ></div>
                        </div>
                      </label>
                    </form>
                  </div>
                </div>
              </div>

              <!-- Block Récapitulatif -->
              <div class="col-12 col-lg-4 py-3 block-recap">
                <label class="title-recap">Récapitulatif de la commande</label>

                <div v-if="showWarehouseNotice" class="alert alert-info my-3">
                  <i class="ti ti-info-circle"></i>
                  <p>
                    <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en cours, les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt logistique avant la fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger retard dans la prise en charge de vos commandes par ces derniers.
                  </p>
                </div>
                
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
                  <label class="recap-text p-0">Prix des produits</label>
                  <span class="recap-text">{{ TotalCart }} € HT</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="showRemiseLine && remise">
                  <p class="col-6 col-lg-6 p-0">
                    <label class="recap-text">Remise</label>
                    <br />
                    <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                    <span class="text-slogan" v-else>inclus dans le prix des produits</span>
                  </p>
                  <span class="recap-text">{{ remise }} €</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text p-0">TVA</label>
                  <span class="recap-text">{{ Tva }} €</span>
                </div>
               
                <div class="my-3 my-md-4 row">
                  <p class="col-12 col-lg-10">
                    <label class="recap-text">Livraison</label>
                    <br />
                    <span class="text-slogan">Frais calculés à l'étape suivante</span>
                  </p>
                </div>
                
                <hr class="divider" />
                
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text">Total TVA inclus</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
                </div>
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-else>
                  <label class="recap-text">Total</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € HT</span>
                </div>
                
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn text-white btn-check-order mt-2 font-16 w-100"
                      :disabled="!selected || loading || isSubmitting || !ModesLivraison.length"
                      @click="GoModeLivraison()"
                    >
                      <span
                        v-if="isSubmitting"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span>{{ isSubmitting ? "Chargement en cours..." : "Choisir ce mode livraison" }}</span>
                    </button>
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies ssl et 3D Secure.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import iconshipping from "@/assets/shipping.svg";
  import { useCartStore } from "@/stores/cartStore";
  import { useShippingMethodesStore } from "@/stores/shippingMethodStore";
  import { useRegisterStore } from "@/stores/register";
  import { updateShipmentShippingMethod, getOrderDetails } from "@/api/orders";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import { useDelegueStore } from '@/stores/delegueStore';
  import { useToast } from "vue-toastification";
export default {
  name: "LivraisonPage",
  setup() {
    const toast = useToast();
    return { toast };
  },
    data() {
      return {
        cart: {
          items: [],
        },
        error: null, // Gestion des erreurs
        cartStore: null,
        shippingMethodStore: null,
        size: "50px",
        color: "#3498db",
        iconshipping,
        selected: null,
        isSubmitting: false,
      };
    },
    computed: {
      spinnerStyle() {
        return {
          width: this.size,
          height: this.size,
          borderColor: `${this.color} transparent transparent transparent`,
        };
      },
      TotalCart() {
        const cartStore = useCartStore();
        let total = 0;
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0) {
          total = cartStore.Cart.itemsSubtotal / 100;
        }
        return this.formatPrice(total);
      },
      Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal) )/ 100;
        return this.formatPrice(total);
      },
      remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },

       tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },

      cartsupp() {
        const cartStore = useCartStore();
        return cartStore.Cart;
      },
      ModesLivraison() {
        return this.shippingMethodStore?.ShippingMethodes || [];
      },
      loading() {
        return this.shippingMethodStore?.loading || false;
      },

      user() {
        return this.registerStore.user;
      },

      selectedVetForDelegue() {
        return this.delegueStore.selectedVeterinarian;
      },

       showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date('2026-01-07T00:00:00');
        return today < deadline;
      },
      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
    },
    created() {
      this.registerStore = useRegisterStore();
      this.shippingMethodStore = useShippingMethodesStore();
      this.delegueStore = useDelegueStore(); 
      this.shippingMethodStore.fetchShippingMethodes(this.user?.role, this.selectedVetForDelegue?.id);
    },

    methods: {
      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value);
        return num.toFixed(2).replace('.', ',');
      },
      async GoModeLivraison() {
        if (this.isSubmitting) return;

        if (!this.ModesLivraison || !this.ModesLivraison.length) {
          this.error = "Les modes de livraison ne sont pas encore disponibles. Veuillez réessayer.";
          return;
        }

        const selectedMode = this.ModesLivraison.find(mode => mode.id === this.selected);

        if (!selectedMode) {
          this.error = "Veuillez sélectionner un mode de livraison valide.";
          return;
        }

        this.isSubmitting = true;

        try {
          const tokenValue = this.cartsupp.tokenValue;

          const order = await getOrderDetails(tokenValue);

          const shippingMethodIRI = `/api/v2/shop/shipping-methods/${selectedMode.code}`;
          const shipmentId = order.data.shipments?.[0]?.id;

          if (!shipmentId) {
            this.error = "Aucun envoi disponible pour cette commande.";
            return;
          }

          //  Patch shipment with selected shipping method
          await updateShipmentShippingMethod(tokenValue, shipmentId, shippingMethodIRI);
          const checkoutStore = useCheckoutStore();
          checkoutStore.setShippingMethod(selectedMode.code);

          switch (selectedMode.code) {
            case "OLD1ID":
            case "OLD7ID":
              this.$router.push({ name: "livraison-clinique" });
              break;
            case "OLD3ID":
              this.$router.push({ name: "livraison-point-relais" });
              break;
            case "OLD8ID":
              this.$router.push({ name: "livraison-domicile" });
              break;
            default:
              this.error = "Code de mode de livraison non reconnu.";
          }
        } catch (err) {
          if (err.response && err.response.status === 422) {
            const detail = err.response.data.detail || (err.response.data.violations && err.response.data.violations[0]?.message);
            this.toast.warning(detail || "Le mode de livraison sélectionné n'est pas disponible.", {
              timeout: 10000
            });
          } else {
            this.error = "Échec de la mise à jour du mode de livraison. Veuillez réessayer.";
          }
          console.error(err);
        } finally {
          this.isSubmitting = false;
        }
      },
      GoToStepCart() {
        this.$router.push({ name: "my-cart" });
      },
      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
    },
  };
</script>

<style scoped>
  .livraison-page {
    padding: 15px;
    text-align: center;
    background: #f5f6f9;
    min-height: 500px;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;
  }

  .section-header-breadcrumb .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  .section-header-breadcrumb .breadcrumb-text {
    font-size: 15px;
    font-weight: normal;
  }

  .section-header-breadcrumb .breadcrumb-text span {
    color: #1e347d;
  }

  .block-livraison {
    background: white;
    padding-top: 2rem;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  .block-livraison .modes-livraison {
    max-height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 2rem;
  }

  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .title-blue {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }

  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }

  /************Modes livraison*******************/
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .radio-option {
    display: flex;
    align-items: flex-start;
    text-align: justify;
    flex-direction: column;
    border: 2px solid #aeb1ba;
    border-radius: 10px;
    padding: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .radio-option:hover,
  .radio-option.selected {
    background: #f5f6f9 0% 0% no-repeat padding-box;
    border: 2px solid #1e347d;
  }

  .radio-option input[type="radio"] {
    margin-right: 16px;
    margin-top: 6px;
    transform: scale(1.2);
    accent-color: #ec621a;
    cursor: pointer;
  }

  .radio-content {
    display: flex;
    flex-direction: column;
  }

  .radio-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  /************Fin mode livraison****************/
  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    max-height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  .block-recap .title-recap {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
  }

  .block-recap .recap-text {
    font-size: 20px;
  }

  .block-recap .recap-text-blue {
    font-size: 20px;
    color: #1e347d;
    font-weight: bold;
  }

  .block-recap .text-slogan {
    font-size: 12px;
    color: #1e347d;
    font-style: italic;
  }

  .block-recap .divider {
    width: 90%;
    position: relative;
    left: 5%;
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .radio-input-title {
    display: flex;
    align-items: flex-start;
  }

  /* Responsive Styles pour mobiles uniquement */
  @media (max-width: 768px) {

    .step-cart-centent{
      display: none !important;
    }

    .livraison-page {
      padding: 10px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
      text-align: center;
    }

    .section-header-breadcrumb .title-page {
      font-size: 24px;
      text-align: center;
    }

    .section-header-breadcrumb .breadcrumb-text {
      font-size: 14px;
      text-align: center;
    }

    .content.cart-page-inner {
      gap: 20px !important;
    }

    .block-livraison {
      padding-top: 1rem;
      margin-bottom: 1rem;
    }

    .step-cart {
      margin-bottom: 1.5rem;
    }

    .step-cart-centent {
      padding: 1rem 0.5rem;
    }

    .badge {
      width: 32px;
      height: 32px;
      font-size: 1rem;
    }

    .step-cart .step-title {
      font-size: 14px;
    }

    .title-blue {
      font-size: 18px;
    }

    .shipping-icon {
      width: 24px;
      height: 24px;
    }

    .radio-option {
      padding: 12px;
    }

    .radio-title {
      font-size: 14px;
    }

    .radio-description {
      font-size: 13px;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
      text-align: center;
      display: block;
      width: 100%;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order {
      width: 100%;
      padding: 12px;
    }

    .separator {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .section-header-breadcrumb .title-page {
      font-size: 20px;
    }

    .badge {
      width: 28px;
      height: 28px;
      font-size: 0.9rem;
    }

    .step-cart .step-title {
      font-size: 12px;
    }

    .title-blue {
      font-size: 16px;
    }

    .radio-option {
      padding: 10px;
    }

    .radio-option input[type="radio"] {
      margin-right: 12px;
      transform: scale(1.1);
    }

    .block-recap {
      padding: 15px;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 14px;
    }
  }

  /* Pour les très petits écrans */
  @media (max-width: 360px) {
    .section-header-breadcrumb .title-page {
      font-size: 18px;
    }

    .breadcrumb-text {
      font-size: 12px !important;
    }

    .badge {
      width: 24px;
      height: 24px;
      font-size: 0.8rem;
    }
  }
</style>